import React, { createContext, useState, useContext, useEffect } from 'react';
import { getAuthToken, getRole, logout as apiLogout } from '../utils/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!getAuthToken());
  const [role, setRole] = useState(getRole());

  useEffect(() => {
    const token = getAuthToken();
    const userRole = getRole();
    setIsAuthenticated(!!token);
    setRole(userRole);
  }, []);

  const login = (token, userRole) => {
    setIsAuthenticated(true);
    setRole(userRole);
  };

  const logout = () => {
    apiLogout();
    setIsAuthenticated(false);
    setRole(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, role, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};